module.exports = __webpack_public_path__ + "components/country-flag/static/lb-a34567740adb95eeb24d6f0b91fc542a.svg";